import { render, staticRenderFns } from "./document-quick-view-modal.vue?vue&type=template&id=5fce130f&"
import script from "./document-quick-view-modal.vue?vue&type=script&lang=js&"
export * from "./document-quick-view-modal.vue?vue&type=script&lang=js&"
import style0 from "./document-quick-view-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "document-quick-view-modal.vue"
export default component.exports